"use strict";

var cov_16osdveakq = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\resources\\useResource.js";
  var hash = "5c711af86863ad559de959f9abbc8fa596c337c1";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\resources\\useResource.js",
    statementMap: {
      "0": {
        start: {
          line: 16,
          column: 52
        },
        end: {
          line: 16,
          column: 62
        }
      },
      "1": {
        start: {
          line: 17,
          column: 34
        },
        end: {
          line: 17,
          column: 44
        }
      },
      "2": {
        start: {
          line: 19,
          column: 20
        },
        end: {
          line: 29,
          column: 45
        }
      },
      "3": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 28,
          column: 5
        }
      },
      "4": {
        start: {
          line: 21,
          column: 26
        },
        end: {
          line: 21,
          column: 34
        }
      },
      "5": {
        start: {
          line: 23,
          column: 6
        },
        end: {
          line: 27,
          column: 7
        }
      },
      "6": {
        start: {
          line: 24,
          column: 21
        },
        end: {
          line: 24,
          column: 46
        }
      },
      "7": {
        start: {
          line: 25,
          column: 8
        },
        end: {
          line: 25,
          column: 26
        }
      },
      "8": {
        start: {
          line: 26,
          column: 8
        },
        end: {
          line: 26,
          column: 49
        }
      },
      "9": {
        start: {
          line: 31,
          column: 2
        },
        end: {
          line: 39,
          column: 48
        }
      },
      "10": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 38,
          column: 6
        }
      },
      "11": {
        start: {
          line: 36,
          column: 8
        },
        end: {
          line: 36,
          column: 26
        }
      },
      "12": {
        start: {
          line: 41,
          column: 17
        },
        end: {
          line: 47,
          column: 3
        }
      },
      "13": {
        start: {
          line: 43,
          column: 25
        },
        end: {
          line: 43,
          column: 59
        }
      },
      "14": {
        start: {
          line: 44,
          column: 6
        },
        end: {
          line: 44,
          column: 29
        }
      },
      "15": {
        start: {
          line: 49,
          column: 2
        },
        end: {
          line: 55,
          column: 4
        }
      },
      "16": {
        start: {
          line: 58,
          column: 0
        },
        end: {
          line: 76,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "useResource",
        decl: {
          start: {
            line: 8,
            column: 9
          },
          end: {
            line: 8,
            column: 20
          }
        },
        loc: {
          start: {
            line: 15,
            column: 3
          },
          end: {
            line: 56,
            column: 1
          }
        },
        line: 15
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 19,
            column: 32
          },
          end: {
            line: 19,
            column: 33
          }
        },
        loc: {
          start: {
            line: 19,
            column: 44
          },
          end: {
            line: 29,
            column: 3
          }
        },
        line: 19
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 31,
            column: 12
          },
          end: {
            line: 31,
            column: 13
          }
        },
        loc: {
          start: {
            line: 31,
            column: 18
          },
          end: {
            line: 39,
            column: 3
          }
        },
        line: 31
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 35,
            column: 6
          },
          end: {
            line: 35,
            column: 7
          }
        },
        loc: {
          start: {
            line: 35,
            column: 21
          },
          end: {
            line: 37,
            column: 7
          }
        },
        line: 35
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 42,
            column: 4
          },
          end: {
            line: 42,
            column: 5
          }
        },
        loc: {
          start: {
            line: 42,
            column: 19
          },
          end: {
            line: 45,
            column: 5
          }
        },
        line: 42
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 28,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 28,
            column: 5
          }
        }, {
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 28,
            column: 5
          }
        }],
        line: 20
      },
      "1": {
        loc: {
          start: {
            line: 20,
            column: 8
          },
          end: {
            line: 20,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 8
          },
          end: {
            line: 20,
            column: 16
          }
        }, {
          start: {
            line: 20,
            column: 20
          },
          end: {
            line: 20,
            column: 36
          }
        }],
        line: 20
      },
      "2": {
        loc: {
          start: {
            line: 23,
            column: 6
          },
          end: {
            line: 27,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 23,
            column: 6
          },
          end: {
            line: 27,
            column: 7
          }
        }, {
          start: {
            line: 23,
            column: 6
          },
          end: {
            line: 27,
            column: 7
          }
        }],
        line: 23
      },
      "3": {
        loc: {
          start: {
            line: 23,
            column: 10
          },
          end: {
            line: 23,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 23,
            column: 10
          },
          end: {
            line: 23,
            column: 50
          }
        }, {
          start: {
            line: 23,
            column: 54
          },
          end: {
            line: 23,
            column: 63
          }
        }],
        line: 23
      },
      "4": {
        loc: {
          start: {
            line: 43,
            column: 25
          },
          end: {
            line: 43,
            column: 59
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 43,
            column: 25
          },
          end: {
            line: 43,
            column: 34
          }
        }, {
          start: {
            line: 43,
            column: 38
          },
          end: {
            line: 43,
            column: 59
          }
        }],
        line: 43
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "5c711af86863ad559de959f9abbc8fa596c337c1"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _deepFreeze = _interopRequireDefault(require("deep-freeze"));

var _useDeepCompareEffect = _interopRequireDefault(require("use-deep-compare-effect"));

var _core = require("../../core");

function useResource(_ref) {
  var resource = _ref.resource,
      resourceLink = _ref.resourceLink,
      onResourceLink = _ref.onResourceLink,
      reference = _ref.reference,
      config = _ref.config,
      onResource = _ref.onResource;
  cov_16osdveakq.f[0]++;

  var _ref2 = (cov_16osdveakq.s[0]++, (0, _react.useState)()),
      _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
      projectIdentifier = _ref3[0],
      setProjectIdentifier = _ref3[1];

  var _ref4 = (cov_16osdveakq.s[1]++, (0, _react.useState)()),
      _ref5 = (0, _slicedToArray2.default)(_ref4, 2),
      usfmJson = _ref5[0],
      setUsfmJson = _ref5[1];

  var parseUsfm = (cov_16osdveakq.s[2]++, (0, _react.useCallback)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    var _ref7, project, json;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            cov_16osdveakq.f[1]++;
            cov_16osdveakq.s[3]++;

            if (!((cov_16osdveakq.b[1][0]++, resource) && (cov_16osdveakq.b[1][1]++, resource.project))) {
              _context.next = 21;
              break;
            }

            cov_16osdveakq.b[0][0]++;
            _ref7 = (cov_16osdveakq.s[4]++, resource), project = _ref7.project;
            cov_16osdveakq.s[5]++;

            if (!((cov_16osdveakq.b[3][0]++, project.identifier !== projectIdentifier) || (cov_16osdveakq.b[3][1]++, !usfmJson))) {
              _context.next = 18;
              break;
            }

            cov_16osdveakq.b[2][0]++;
            cov_16osdveakq.s[6]++;
            _context.next = 11;
            return project.parseUsfm();

          case 11:
            json = _context.sent;
            cov_16osdveakq.s[7]++;
            setUsfmJson(json);
            cov_16osdveakq.s[8]++;
            setProjectIdentifier(project.identifier);
            _context.next = 19;
            break;

          case 18:
            cov_16osdveakq.b[2][1]++;

          case 19:
            _context.next = 22;
            break;

          case 21:
            cov_16osdveakq.b[0][1]++;

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [projectIdentifier, resource, usfmJson]));
  cov_16osdveakq.s[9]++;
  (0, _useDeepCompareEffect.default)(function () {
    cov_16osdveakq.f[2]++;
    cov_16osdveakq.s[10]++;
    (0, _core.resourceFromResourceLink)({
      resourceLink: resourceLink,
      reference: reference,
      config: config
    }).then(function (_resource) {
      cov_16osdveakq.f[3]++;
      cov_16osdveakq.s[11]++;
      update(_resource);
    });
  }, [resourceLink, reference, config, update]);
  var update = (cov_16osdveakq.s[12]++, (0, _react.useCallback)(function (_resource) {
    cov_16osdveakq.f[4]++;

    var __resource = (cov_16osdveakq.s[13]++, (cov_16osdveakq.b[4][0]++, _resource) && (cov_16osdveakq.b[4][1]++, (0, _deepFreeze.default)(_resource)));

    cov_16osdveakq.s[14]++;
    onResource(__resource);
  }, [onResource]));
  cov_16osdveakq.s[15]++;
  return {
    state: resource,
    actions: {
      update: update,
      parseUsfm: parseUsfm
    }
  };
}

cov_16osdveakq.s[16]++;
useResource.propTypes = {
  /** the resource content */
  resource: _propTypes.default.object,

  /** reference: chapter and verse */
  reference: _propTypes.default.object,

  /** The link to parse and fetch the resource manifest */
  resourceLink: _propTypes.default.string.isRequired,

  /** The configuration of the server, and fetching */
  config: _propTypes.default.shape({
    server: _propTypes.default.string.isRequired,

    /** the overriding cache settings */
    cache: _propTypes.default.shape({
      /** cache age in ms */
      maxAge: _propTypes.default.number
    })
  }),

  /** action taken after a resource is acquired */
  onResource: _propTypes.default.func.isRequired
};
var _default = useResource;
exports.default = _default;